var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-height" },
    [
      !_vm.userInfo.agencyCode
        ? _c("no-auth")
        : _c(
            "div",
            {
              staticClass: "coupon-category-app-container",
              staticStyle: { position: "relative", height: "100%" },
            },
            [
              _c(
                "el-dialog",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dialogLoading,
                      expression: "dialogLoading",
                    },
                  ],
                  attrs: {
                    top: _vm.dialogTopMargin,
                    title: _vm.funcName + "維護",
                    visible: _vm.dialogVisible,
                    width: "50%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.form,
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.funcName + "名稱" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v("確 定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticClass: "filter-form",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "查詢" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "輸入團號/團名" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getAgencyTravelsAndOtherInformation(
                              $event
                            )
                          },
                        },
                        model: {
                          value: _vm.listQuery.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "qry", $$v)
                          },
                          expression: "listQuery.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-button", {
                    staticStyle: { "margin-top": "8px", "margin-left": "5px" },
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      circle: "",
                      disabled: _vm.listLoading,
                    },
                    on: { click: _vm.getAgencyTravelsAndOtherInformation },
                  }),
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      type: "success",
                      loading: _vm.listLoading,
                      circle: "",
                      icon: "el-icon-refresh-left",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { position: "relative", height: "80%" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "formDetailsTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        size: "mini",
                        data: _vm.list,
                        border: "",
                        height: "100%",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "數量",
                          width: "1",
                          type: "expand",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "mini",
                                      data: scope.row.travelResultCommonForms,
                                      border: "",
                                      height: "200",
                                      "row-class-name": _vm.tableRowClassName,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "項次",
                                        width: "50",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.$index + 1) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "回傳者",
                                        width: "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.formFile &&
                                                scope.row.formFile.leaderInfo
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row.formFile
                                                              .leaderInfo.name
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "旅客名稱",
                                        width: "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.formFile &&
                                                scope.row.formFile.travelerInfo
                                                  ? _c(
                                                      "span",
                                                      _vm._l(
                                                        scope.row.formFile
                                                          .travelerInfo.name,
                                                        function (
                                                          travelerItem,
                                                          travelerItemIndex
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            {
                                                              key:
                                                                travelerItemIndex +
                                                                "_" +
                                                                travelerItem,
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    travelerItem
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        travelerItemIndex !=
                                                                        scope
                                                                          .row
                                                                          .formFile
                                                                          .travelerInfo
                                                                          .name
                                                                          .length -
                                                                          1,
                                                                      expression:
                                                                        "\n                          travelerItemIndex != scope.row.formFile.travelerInfo.name.length - 1\n                        ",
                                                                    },
                                                                  ],
                                                                },
                                                                [_vm._v("、")]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "描述",
                                        width: "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.row.formDesc) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "檔案名稱",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.formFile &&
                                                scope.row.formFile.fileInfo
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row.formFile
                                                              .fileInfo
                                                              .fileRealName
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "下載",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.formFile &&
                                                scope.row.formFile.fileInfo
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              size: "mini",
                                                              type: "info",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadFile(
                                                                  scope.row
                                                                    .formFile
                                                                    .fileInfo
                                                                    .id,
                                                                  scope.row
                                                                    .formFile
                                                                    .fileInfo
                                                                    .fileRealName
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("下載")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "刪除",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.formFile &&
                                                scope.row.formFile.fileInfo
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              size: "mini",
                                                              type: "danger",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteResultForm(
                                                                  scope.row
                                                                    .formID,
                                                                  scope.row
                                                                    .formFile
                                                                    .fileInfo
                                                                    .fileRealName
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("刪除")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tourGroupNo",
                          label: "團號",
                          width: "200",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "團名", width: "450" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("span", [_vm._v(_vm._s(row.travelName))]),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tag",
                                      { staticStyle: { "font-size": "14px" } },
                                      [
                                        _vm._v(" 出發 "),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                row.beginDate +
                                                  " " +
                                                  row.beginTime
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" - 回程 "),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                row.endDate + " " + row.endTime
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "數量", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      "font-size": "20px",
                                      "font-weight": "bold",
                                      cursor: "pointer",
                                    },
                                    attrs: { type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleExpand(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        row.travelResultCommonForms.length
                                      ) + " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0",
                  },
                ],
                attrs: {
                  layout: "prev, pager, next",
                  total: _vm.total,
                  page: _vm.listQuery.page,
                  limit: _vm.listQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "limit", $event)
                  },
                  pagination: _vm.getAgencyTravelsAndOtherInformation,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }